export default __webpack_public_path__ + "static/media/856.dc947846.gif";